
import projectAdd  from './project-add'
import projectEditor  from './project-editor'

export default {
  props: ['mapTool', 'building', 'originCheckVal'],
  watch: {
  },
  components: {
    projectAdd,
    projectEditor
  },
  data() {
    return {
      isNext: true,
      layerLoading: false,
      showIndoor: false,
      list: [],
      proList: []
    }
  },
  mounted() {
    
  },
  destroyed() {
    this.$layer.closeAll()
  },
  methods: {
    putProjectOne(data) {
        this.$refs.projectAddRef.putProjectOne(data)
    },
    addProjectsLayerToMap(isLayerToMap) {
      this.$emit('addProjectsLayerToMap', isLayerToMap)
    },
    inProjectDraw(isIn) {
      this.$emit('inProjectDraw', isIn)
    },
    addProj() {
      this.isNext = false
    },
    showPop() {        
      this.showIndoor = true
    },
    hidePop() {
      this.isNext = true
      this.showIndoor = false
      $('#mapboxglXiangmu').removeClass('active')
      this.$emit('closeProject')
    }

  },
};
